// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import {
//   Card,
//   CardTitle,
//   CardBody,
//   Button,
//   Input,
//   Row,
//   Col,
//   Label,
// } from 'reactstrap';
// import { useSelector } from 'react-redux';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { apiService } from '../../constants/ApiService';
// import './TimeTableBoard.css';

// const ROW_HEIGHT = 72;

// const DAYS = [
//   { day_id: 1, day_name: 'Monday' },
//   { day_id: 2, day_name: 'Tuesday' },
//   { day_id: 3, day_name: 'Wednesday' },
//   { day_id: 4, day_name: 'Thursday' },
//   { day_id: 5, day_name: 'Friday' },
//   { day_id: 6, day_name: 'Saturday' },
//   { day_id: 7, day_name: 'Sunday' },
// ];

// const parseTimeToMinutes = (value) => {
//   if (!value) return 0;

//   const parts = String(value).split(':');
//   const hour = Number(parts[0] || 0);
//   const minute = Number(parts[1] || 0);

//   return hour * 60 + minute;
// };

// const minutesToTimeValue = (totalMinutes) => {
//   const hour = Math.floor(totalMinutes / 60);
//   const minute = totalMinutes % 60;

//   return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00`;
// };

// const format12HourTime = (value) => {
//   if (!value) return '';

//   const parts = String(value).split(':');
//   let hour = Number(parts[0] || 0);
//   const minute = Number(parts[1] || 0);

//   const ampm = hour >= 12 ? 'PM' : 'AM';
//   hour = hour % 12;
//   if (hour === 0) hour = 12;

//   return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
// };

// const buildTimeSlots = (dayStartTime, dayEndTime, slotMinutes) => {
//   if (!dayStartTime || !dayEndTime) return [];

//   const start = parseTimeToMinutes(dayStartTime);
//   const end = parseTimeToMinutes(dayEndTime);
//   const step = Number(slotMinutes || 30);

//   const safeEnd = end > start ? end : start + step;

//   const slots = [];
//   for (let t = start; t < safeEnd; t += step) {
//     slots.push({
//       time: t,
//       label: format12HourTime(minutesToTimeValue(t)),
//     });
//   }

//   if (!slots.length) {
//     slots.push({
//       time: start,
//       label: format12HourTime(minutesToTimeValue(start)),
//     });
//   }

//   return slots;
// };

// const buildDayLayouts = (days = [], items = []) => {
//   const result = {};

//   days.forEach((d) => {
//     const dayItems = items
//       .filter((x) => Number(x.day_id) === Number(d.day_id))
//       .map((x) => ({
//         ...x,
//         _start: parseTimeToMinutes(x.start_time),
//         _end: parseTimeToMinutes(x.end_time),
//       }))
//       .sort((a, b) => a._start - b._start);

//     const groups = [];
//     let currentGroup = [];
//     let currentGroupEnd = -1;

//     dayItems.forEach((item) => {
//       if (currentGroup.length === 0) {
//         currentGroup = [item];
//         currentGroupEnd = item._end;
//       } else if (item._start < currentGroupEnd) {
//         currentGroup.push(item);
//         currentGroupEnd = Math.max(currentGroupEnd, item._end);
//       } else {
//         groups.push(currentGroup);
//         currentGroup = [item];
//         currentGroupEnd = item._end;
//       }
//     });

//     if (currentGroup.length) groups.push(currentGroup);

//     const laidOut = [];

//     groups.forEach((group) => {
//       const colEndTimes = [];

//       group.forEach((item) => {
//         let colIndex = colEndTimes.findIndex((end) => end <= item._start);

//         if (colIndex === -1) {
//           colIndex = colEndTimes.length;
//           colEndTimes.push(item._end);
//         } else {
//           colEndTimes[colIndex] = item._end;
//         }

//         item._colIndex = colIndex;
//       });

//       const totalCols = colEndTimes.length;

//       group.forEach((item) => {
//         laidOut.push({
//           ...item,
//           _totalCols: totalCols,
//         });
//       });
//     });

//     result[d.day_id] = laidOut;
//   });

//   return result;
// };

// const getValueFromKeys = (row, keys = []) => {
//   for (const key of keys) {
//     if (row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== '') {
//       return row[key];
//     }
//   }
//   return '';
// };

// const mapDropdownData = (rows = [], valueKeys = [], labelKeys = []) => {
//   return rows
//     .map((row) => ({
//       value: getValueFromKeys(row, valueKeys),
//       label: getValueFromKeys(row, labelKeys),
//     }))
//     .filter((x) => x.value !== '' && x.label !== '');
// };

// const TimeTableBoard = () => {
//   const { user } = useSelector((state) => state.authState || {});

//   const userProfile =
//     user?.user_profile && typeof user?.user_profile === 'object'
//       ? user.user_profile
//       : user?.UserProfile || {};

//   const roleText = [
//     userProfile?.role_name,
//     userProfile?.RoleName,
//     userProfile?.user_profile,
//     userProfile?.role,
//     userProfile?.Role,
//     userProfile?.user_type,
//     userProfile?.UserType,
//     userProfile?.login_type,
//     userProfile?.LoginType,
//     user?.role_name,
//     user?.RoleName,
//     typeof user?.user_profile === 'string' ? user.user_profile : '',
//     user?.role,
//     user?.Role,
//     user?.user_type,
//     user?.UserType,
//     user?.login_type,
//     user?.LoginType,
//   ]
//     .filter(Boolean)
//     .join(' ')
//     .trim()
//     .toLowerCase();

//   const isStudent = roleText.includes('student');

//   const showClassBatchDropdown =
//     !isStudent &&
//     (roleText.includes('superadmin') ||
//       roleText.includes('super admin') ||
//       roleText.includes('supervendor') ||
//       roleText.includes('super vendor') ||
//       roleText.includes('admin') ||
//       roleText.includes('faculty'));

//   const getUserVendorId = () =>
//     userProfile?.vendor_id ||
//     userProfile?.vendorId ||
//     userProfile?.VendorID ||
//     user?.vendor_id ||
//     user?.vendorId ||
//     user?.VendorID ||
//     '';

//   const getUserBranchId = () =>
//     userProfile?.branch_id ||
//     userProfile?.branchId ||
//     userProfile?.BranchID ||
//     user?.branch_id ||
//     user?.branchId ||
//     user?.BranchID ||
//     '';

//   const getStudentClassId = () =>
//     userProfile?.class_id || userProfile?.classId || userProfile?.ClassID || '';

//   const getStudentBatchId = () =>
//     userProfile?.batch_id || userProfile?.batchId || userProfile?.BatchID || '';

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const [loading, setLoading] = useState(false);
//   const [classList, setClassList] = useState([]);
//   const [batchList, setBatchList] = useState([]);
//   const [filterData, setFilterData] = useState({
//     class_id: '',
//     batch_id: '',
//   });

//   const [board, setBoard] = useState({
//     status: false,
//     Message: '',
//     day_start_time: null,
//     day_end_time: null,
//     slot_minutes: 30,
//     items: [],
//   });

//   useEffect(() => {
//     setSelectionData((prev) => ({
//       vendor_id: prev?.vendor_id || getUserVendorId() || '',
//       branch_id: prev?.branch_id || getUserBranchId() || '',
//     }));
//   }, [user]);

//   useEffect(() => {
//     if (isStudent) {
//       setFilterData({
//         class_id: getStudentClassId() || '',
//         batch_id: getStudentBatchId() || '',
//       });
//     }
//   }, [isStudent, user]);

//   const activeClassId = isStudent ? getStudentClassId() : filterData?.class_id;
//   const activeBatchId = isStudent ? getStudentBatchId() : filterData?.batch_id;

//   const loadBoard = useCallback(async () => {
//     // if (!selectionData?.vendor_id || !selectionData?.branch_id) return;

//     try {
//       setLoading(true);

//       const params = new URLSearchParams({
//         vendorId: String(selectionData.vendor_id),
//         branchId: String(selectionData.branch_id),
//         search: '',
//       });

//       if (activeClassId) params.append('classId', String(activeClassId));
//       if (activeBatchId) params.append('batchId', String(activeBatchId));

//       const response = await apiService.get(
//         `api/TimeTableMaster/GetWeeklyTimeTable?${params.toString()}`,
//       );

//       if (response?.status === true) {
//         setBoard({
//           status: response.status,
//           Message: response.Message || response.message || '',
//           day_start_time: response.day_start_time || null,
//           day_end_time: response.day_end_time || null,
//           slot_minutes: response.slot_minutes || 30,
//           items: Array.isArray(response.items) ? response.items : [],
//         });
//       } else {
//         alert(
//           response?.Message || response?.message || 'Failed to load timetable',
//         );
//       }
//     } catch (err) {
//       console.error(err);
//       alert('Something went wrong');
//     } finally {
//       setLoading(false);
//     }
//   }, [
//     selectionData?.vendor_id,
//     selectionData?.branch_id,
//     activeClassId,
//     activeBatchId,
//   ]);

//   const fetchClasses = useCallback(async () => {
//     try {
//       const vendorId = selectionData?.vendor_id || '';
//       const branchId = selectionData?.branch_id || '';

//       // if (!vendorId || !branchId || !showClassBatchDropdown) {
//       //   setClassList([]);
//       //   return;
//       // }

//       const response = await apiService.get(
//         `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=`,
//       );

//       const raw = Array.isArray(response?.data) ? response.data : [];
//       const mapped = mapDropdownData(
//         raw,
//         ['class_id', 'id', 'ID'],
//         ['class_Name', 'class_name', 'name', 'Name', 'className'],
//       );

//       setClassList(mapped);
//     } catch (error) {
//       console.log(error);
//       setClassList([]);
//     }
//   }, [
//     selectionData?.vendor_id,
//     selectionData?.branch_id,
//     showClassBatchDropdown,
//   ]);

//   const getBatchListData = useCallback(
//     async (classIdValue) => {
//       try {
//         const vendorId = selectionData?.vendor_id || '';
//         const branchId = selectionData?.branch_id || '';

//         // if (
//         //   !vendorId ||
//         //   !branchId ||
//         //   !classIdValue ||
//         //   !showClassBatchDropdown
//         // ) {
//         //   setBatchList([]);
//         //   return;
//         // }

//         const response = await apiService.get(
//           `api/BatchMaster/GetAllBatch?classId=${classIdValue}&vendorId=${vendorId}&branchId=${branchId}&search=`,
//         );

//         if (response?.status === true) {
//           const raw = Array.isArray(response?.data) ? response.data : [];
//           const mapped = mapDropdownData(
//             raw,
//             ['batch_id', 'id', 'ID'],
//             ['batch_name', 'name', 'Name', 'batchName'],
//           );
//           setBatchList(mapped);
//         } else {
//           setBatchList([]);
//         }
//       } catch (error) {
//         console.log(error);
//         setBatchList([]);
//       }
//     },
//     [
//       selectionData?.vendor_id,
//       selectionData?.branch_id,
//       showClassBatchDropdown,
//     ],
//   );

//   useEffect(() => {
//     // if (selectionData?.vendor_id && selectionData?.branch_id) {
//     loadBoard();
//     // }
//   }, []);

//   useEffect(() => {
//     if (
//       showClassBatchDropdown &&
//       selectionData?.vendor_id &&
//       selectionData?.branch_id
//     ) {
//       fetchClasses();
//     } else {
//       setClassList([]);
//       setBatchList([]);

//       if (!isStudent) {
//         setFilterData({
//           class_id: '',
//           batch_id: '',
//         });
//       }
//     }
//   }, [
//     showClassBatchDropdown,
//     selectionData?.vendor_id,
//     selectionData?.branch_id,
//     fetchClasses,
//     isStudent,
//   ]);

//   useEffect(() => {
//     if (showClassBatchDropdown && filterData?.class_id) {
//       getBatchListData(filterData.class_id);
//     } else {
//       setBatchList([]);

//       if (!isStudent) {
//         setFilterData((prev) => ({
//           ...prev,
//           batch_id: '',
//         }));
//       }
//     }
//   }, [
//     showClassBatchDropdown,
//     filterData?.class_id,
//     getBatchListData,
//     isStudent,
//   ]);

//   const filteredItems = useMemo(() => {
//     let rows = Array.isArray(board.items) ? [...board.items] : [];

//     if (activeClassId) {
//       rows = rows.filter(
//         (x) =>
//           String(x?.class_id || x?.classId || '') === String(activeClassId),
//       );
//     }

//     if (activeBatchId) {
//       rows = rows.filter(
//         (x) =>
//           String(x?.batch_id || x?.batchId || '') === String(activeBatchId),
//       );
//     }

//     return rows;
//   }, [board.items, activeClassId, activeBatchId]);

//   const days = useMemo(() => DAYS, []);

//   const slots = useMemo(() => {
//     return buildTimeSlots(
//       board.day_start_time,
//       board.day_end_time,
//       board.slot_minutes,
//     );
//   }, [board.day_start_time, board.day_end_time, board.slot_minutes]);

//   const minuteHeight = useMemo(() => {
//     const slotMinutes = Number(board.slot_minutes || 30);
//     return ROW_HEIGHT / slotMinutes;
//   }, [board.slot_minutes]);

//   const startMinute = useMemo(
//     () => parseTimeToMinutes(board.day_start_time || '00:00:00'),
//     [board.day_start_time],
//   );

//   const totalHeight = useMemo(() => (slots.length || 0) * ROW_HEIGHT, [slots]);

//   const dayLayouts = useMemo(
//     () => buildDayLayouts(days || [], filteredItems || []),
//     [days, filteredItems],
//   );

//   return (
//     <div className='time-table-page'>
//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 mb-0'>Filter</CardTitle>
//         <CardBody>
//           {!isStudent && (
//             <VendorBranchSelector
//               user={user || {}}
//               selectionData={selectionData || { vendor_id: '', branch_id: '' }}
//               setSelectionData={setSelectionData}
//               errorMessage={{}}
//               accessButton={true}
//             />
//           )}

//           {showClassBatchDropdown && (
//             <Row className='mt-3'>
//               <Col md='5'>
//                 <Label className='form-label'>Class</Label>
//                 <Input
//                   type='select'
//                   className='custom-select'
//                   value={filterData?.class_id || ''}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setFilterData((prev) => ({
//                       ...prev,
//                       class_id: value,
//                       batch_id: '',
//                     }));
//                   }}
//                 >
//                   <option value=''>Select Class</option>
//                   {classList.map((item) => (
//                     <option key={item.value} value={item.value}>
//                       {item.label}
//                     </option>
//                   ))}
//                 </Input>
//               </Col>

//               <Col md='5'>
//                 <Label className='form-label'>Batch</Label>
//                 <Input
//                   type='select'
//                   className='custom-select'
//                   value={filterData?.batch_id || ''}
//                   disabled={!filterData?.class_id}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setFilterData((prev) => ({
//                       ...prev,
//                       batch_id: value,
//                     }));
//                   }}
//                 >
//                   <option value=''>Select Batch</option>
//                   {batchList.map((item) => (
//                     <option key={item.value} value={item.value}>
//                       {item.label}
//                     </option>
//                   ))}
//                 </Input>
//               </Col>

//               <Col md='2' className='d-flex align-items-end'>
//                 <Button color='success' className='w-100' onClick={loadBoard}>
//                   Load
//                 </Button>
//               </Col>
//             </Row>
//           )}

//           {isStudent && (
//             <Row className='mt-3'>
//               <Col md='2' className='d-flex align-items-end ms-auto'>
//                 <Button color='success' className='w-100' onClick={loadBoard}>
//                   Load
//                 </Button>
//               </Col>
//             </Row>
//           )}
//         </CardBody>
//       </Card>

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 mb-0 d-flex justify-content-between align-items-center'>
//           <span>Weekly Timetable</span>
//           <span className='text-muted small'>
//             Time Range: {format12HourTime(board.day_start_time)} -{' '}
//             {format12HourTime(board.day_end_time)}
//           </span>
//         </CardTitle>

//         <CardBody>
//           {loading ? (
//             <div className='text-center p-5'>Loading...</div>
//           ) : (
//             <div className='weekly-board'>
//               <div className='board-header'>
//                 <div className='time-header-cell'>Time</div>

//                 {days.map((day) => (
//                   <div key={day.day_id} className='day-header-cell'>
//                     <div className='day-name'>{day.day_name}</div>
//                   </div>
//                 ))}
//               </div>

//               <div className='board-body'>
//                 <div className='time-column' style={{ height: totalHeight }}>
//                   {slots.map((slot) => (
//                     <div
//                       key={slot.label}
//                       className='time-row-label'
//                       style={{ height: ROW_HEIGHT }}
//                     >
//                       {slot.label}
//                     </div>
//                   ))}
//                 </div>

//                 {days.map((day) => {
//                   const items = dayLayouts[day.day_id] || [];

//                   return (
//                     <div
//                       key={day.day_id}
//                       className='day-column'
//                       style={{ height: totalHeight }}
//                     >
//                       {slots.map((slot) => (
//                         <div
//                           key={`${day.day_id}_${slot.label}`}
//                           className='day-grid-row'
//                           style={{ height: ROW_HEIGHT }}
//                         />
//                       ))}

//                       {items.map((item, index) => {
//                         const top =
//                           (item._start - startMinute) * minuteHeight + 4;

//                         const height = Math.max(
//                           (item._end - item._start) * minuteHeight - 8,
//                           56,
//                         );

//                         const width = `calc(${100 / item._totalCols}% - 8px)`;
//                         const left = `calc(${(100 / item._totalCols) * item._colIndex}% + 4px)`;

//                         return (
//                           <div
//                             key={item.id || `${day.day_id}_${index}`}
//                             className='timetable-card'
//                             style={{ top, height, left, width }}
//                           >
//                             <div className='tt-title'>
//                               {item.subject_name || 'Subject'}
//                             </div>

//                             <div className='tt-time'>
//                               {format12HourTime(item.start_time)} -{' '}
//                               {format12HourTime(item.end_time)}
//                             </div>

//                             <div className='tt-meta'>
//                               <strong>Class:</strong> {item.class_name || '-'}
//                             </div>

//                             <div className='tt-meta'>
//                               <strong>Batch:</strong> {item.batch_name || '-'}
//                             </div>

//                             <div className='tt-meta'>
//                               <strong>Faculty:</strong>{' '}
//                               {item.faculty_name || '-'}
//                             </div>

//                             <div className='tt-meta'>
//                               <strong>Students:</strong>{' '}
//                               {item.student_count || 0}
//                             </div>

//                             {!!item.student_names_text && (
//                               <div className='tt-students'>
//                                 {item.student_names_text}
//                               </div>
//                             )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default TimeTableBoard;
//heena
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Input,
  Row,
  Col,
  Label,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { apiService } from '../../constants/ApiService';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';
import './TimeTableBoard.css';

const MODULE_NAME = 'TimeTable';
const ROW_HEIGHT = 72;

const DAYS = [
  { day_id: 1, day_name: 'Monday' },
  { day_id: 2, day_name: 'Tuesday' },
  { day_id: 3, day_name: 'Wednesday' },
  { day_id: 4, day_name: 'Thursday' },
  { day_id: 5, day_name: 'Friday' },
  { day_id: 6, day_name: 'Saturday' },
  { day_id: 7, day_name: 'Sunday' },
];

const getDefaultBoard = () => ({
  status: false,
  Message: '',
  day_start_time: null,
  day_end_time: null,
  slot_minutes: 30,
  items: [],
});

const parseTimeToMinutes = (value) => {
  if (!value) return 0;

  const parts = String(value).split(':');
  const hour = Number(parts[0] || 0);
  const minute = Number(parts[1] || 0);

  return hour * 60 + minute;
};

const minutesToTimeValue = (totalMinutes) => {
  const hour = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00`;
};

const format12HourTime = (value) => {
  if (!value) return '';

  const parts = String(value).split(':');
  let hour = Number(parts[0] || 0);
  const minute = Number(parts[1] || 0);

  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  if (hour === 0) hour = 12;

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
};

const buildTimeSlots = (dayStartTime, dayEndTime, slotMinutes) => {
  if (!dayStartTime || !dayEndTime) return [];

  const start = parseTimeToMinutes(dayStartTime);
  const end = parseTimeToMinutes(dayEndTime);
  const step = Number(slotMinutes || 30);

  const safeEnd = end > start ? end : start + step;

  const slots = [];
  for (let t = start; t < safeEnd; t += step) {
    slots.push({
      time: t,
      label: format12HourTime(minutesToTimeValue(t)),
    });
  }

  if (!slots.length) {
    slots.push({
      time: start,
      label: format12HourTime(minutesToTimeValue(start)),
    });
  }

  return slots;
};

const buildDayLayouts = (days = [], items = []) => {
  const result = {};

  days.forEach((d) => {
    const dayItems = items
      .filter((x) => Number(x.day_id) === Number(d.day_id))
      .map((x) => ({
        ...x,
        _start: parseTimeToMinutes(x.start_time),
        _end: parseTimeToMinutes(x.end_time),
      }))
      .sort((a, b) => a._start - b._start);

    const groups = [];
    let currentGroup = [];
    let currentGroupEnd = -1;

    dayItems.forEach((item) => {
      if (currentGroup.length === 0) {
        currentGroup = [item];
        currentGroupEnd = item._end;
      } else if (item._start < currentGroupEnd) {
        currentGroup.push(item);
        currentGroupEnd = Math.max(currentGroupEnd, item._end);
      } else {
        groups.push(currentGroup);
        currentGroup = [item];
        currentGroupEnd = item._end;
      }
    });

    if (currentGroup.length) groups.push(currentGroup);

    const laidOut = [];

    groups.forEach((group) => {
      const colEndTimes = [];

      group.forEach((item) => {
        let colIndex = colEndTimes.findIndex((end) => end <= item._start);

        if (colIndex === -1) {
          colIndex = colEndTimes.length;
          colEndTimes.push(item._end);
        } else {
          colEndTimes[colIndex] = item._end;
        }

        item._colIndex = colIndex;
      });

      const totalCols = colEndTimes.length;

      group.forEach((item) => {
        laidOut.push({
          ...item,
          _totalCols: totalCols,
        });
      });
    });

    result[d.day_id] = laidOut;
  });

  return result;
};

const getValueFromKeys = (row, keys = []) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== '') {
      return row[key];
    }
  }
  return '';
};

const mapDropdownData = (rows = [], valueKeys = [], labelKeys = []) => {
  return rows
    .map((row) => ({
      value: getValueFromKeys(row, valueKeys),
      label: getValueFromKeys(row, labelKeys),
    }))
    .filter((x) => x.value !== '' && x.label !== '');
};

const TimeTableBoard = () => {
  const { user } = useSelector((state) => state.authState || {});
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const userProfile =
    user?.user_profile && typeof user?.user_profile === 'object'
      ? user.user_profile
      : user?.UserProfile || {};

  const roleText = [
    userProfile?.role_name,
    userProfile?.RoleName,
    userProfile?.user_profile,
    userProfile?.role,
    userProfile?.Role,
    userProfile?.user_type,
    userProfile?.UserType,
    userProfile?.login_type,
    userProfile?.LoginType,
    user?.role_name,
    user?.RoleName,
    typeof user?.user_profile === 'string' ? user.user_profile : '',
    user?.role,
    user?.Role,
    user?.user_type,
    user?.UserType,
    user?.login_type,
    user?.LoginType,
  ]
    .filter(Boolean)
    .join(' ')
    .trim()
    .toLowerCase();

  const isStudent = roleText.includes('student');

  const showClassBatchDropdown =
    !isStudent &&
    (roleText.includes('superadmin') ||
      roleText.includes('super admin') ||
      roleText.includes('supervendor') ||
      roleText.includes('super vendor') ||
      roleText.includes('admin') ||
      roleText.includes('faculty'));

  const getUserVendorId = () =>
    userProfile?.vendor_id ||
    userProfile?.vendorId ||
    userProfile?.VendorID ||
    user?.vendor_id ||
    user?.vendorId ||
    user?.VendorID ||
    '';

  const getUserBranchId = () =>
    userProfile?.branch_id ||
    userProfile?.branchId ||
    userProfile?.BranchID ||
    user?.branch_id ||
    user?.branchId ||
    user?.BranchID ||
    '';

  const getStudentClassId = () =>
    userProfile?.class_id || userProfile?.classId || userProfile?.ClassID || '';

  const getStudentBatchId = () =>
    userProfile?.batch_id || userProfile?.batchId || userProfile?.BatchID || '';

  const [errorMessage, setErrorMessage] = useState({});
  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [loading, setLoading] = useState(false);
  const [classList, setClassList] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [filterData, setFilterData] = useState({
    class_id: '',
    batch_id: '',
  });

  const [board, setBoard] = useState(getDefaultBoard());

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  useEffect(() => {
    setSelectionData((prev) => ({
      vendor_id: prev?.vendor_id || getUserVendorId() || '',
      branch_id: prev?.branch_id || getUserBranchId() || '',
    }));
  }, [user]);

  useEffect(() => {
    if (isStudent) {
      setFilterData({
        class_id: getStudentClassId() || '',
        batch_id: getStudentBatchId() || '',
      });
    }
  }, [isStudent, user]);

  const activeClassId = isStudent ? getStudentClassId() : filterData?.class_id;
  const activeBatchId = isStudent ? getStudentBatchId() : filterData?.batch_id;

  const loadBoard = useCallback(async () => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData?.vendor_id,
      branchId: selectionData?.branch_id,
    });

    if (!canLoad) {
      setBoard(getDefaultBoard());
      return;
    }

    try {
      setLoading(true);

      const params = new URLSearchParams({
        vendorId: String(selectionData?.vendor_id || ''),
        branchId: String(selectionData?.branch_id || ''),
        search: '',
      });

      if (activeClassId) params.append('classId', String(activeClassId));
      if (activeBatchId) params.append('batchId', String(activeBatchId));

      const response = await apiService.get(
        `api/TimeTableMaster/GetWeeklyTimeTable?${params.toString()}`,
      );

      if (response?.status === true) {
        setBoard({
          status: response?.status,
          Message: response?.Message || response?.message || '',
          day_start_time: response?.day_start_time || null,
          day_end_time: response?.day_end_time || null,
          slot_minutes: response?.slot_minutes || 30,
          items: Array.isArray(response?.items) ? response.items : [],
        });
      } else {
        setBoard({
          ...getDefaultBoard(),
          Message:
            response?.Message ||
            response?.message ||
            'Failed to load timetable',
        });
      }
    } catch (err) {
      console.error(err);
      setBoard({
        ...getDefaultBoard(),
        Message: 'Something went wrong',
      });
    } finally {
      setLoading(false);
    }
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    activeClassId,
    activeBatchId,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  const fetchClasses = useCallback(async () => {
    try {
      const canLoad = conditionalDataLoad({
        hasMultiBranch,
        hasSingleBranch,
        isSuperAdmin,
        isAdmin,
        vendorId: selectionData?.vendor_id,
        branchId: selectionData?.branch_id,
      });

      const vendorId = selectionData?.vendor_id || '';
      const branchId = selectionData?.branch_id || '';

      if (!canLoad || !showClassBatchDropdown) {
        setClassList([]);
        return;
      }

      const response = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=`,
      );

      const raw = Array.isArray(response?.data) ? response.data : [];
      const mapped = mapDropdownData(
        raw,
        ['class_id', 'id', 'ID'],
        ['class_Name', 'class_name', 'name', 'Name', 'className'],
      );

      setClassList(mapped);
    } catch (error) {
      console.log(error);
      setClassList([]);
    }
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    showClassBatchDropdown,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  const getBatchListData = useCallback(
    async (classIdValue) => {
      try {
        const canLoad = conditionalDataLoad({
          hasMultiBranch,
          hasSingleBranch,
          isSuperAdmin,
          isAdmin,
          vendorId: selectionData?.vendor_id,
          branchId: selectionData?.branch_id,
        });

        const vendorId = selectionData?.vendor_id || '';
        const branchId = selectionData?.branch_id || '';

        if (!canLoad || !showClassBatchDropdown || !classIdValue) {
          setBatchList([]);
          return;
        }

        const response = await apiService.get(
          `api/BatchMaster/GetAllBatch?classId=${classIdValue}&vendorId=${vendorId}&branchId=${branchId}&search=`,
        );

        if (response?.status === true) {
          const raw = Array.isArray(response?.data) ? response.data : [];
          const mapped = mapDropdownData(
            raw,
            ['batch_id', 'id', 'ID'],
            ['batch_name', 'name', 'Name', 'batchName'],
          );
          setBatchList(mapped);
        } else {
          setBatchList([]);
        }
      } catch (error) {
        console.log(error);
        setBatchList([]);
      }
    },
    [
      selectionData?.vendor_id,
      selectionData?.branch_id,
      showClassBatchDropdown,
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
    ],
  );

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData?.vendor_id,
      branchId: selectionData?.branch_id,
    });

    if (showClassBatchDropdown && canLoad) {
      fetchClasses();
    } else {
      setClassList([]);
      setBatchList([]);

      if (!isStudent) {
        setFilterData({
          class_id: '',
          batch_id: '',
        });
      }
    }
  }, [
    showClassBatchDropdown,
    selectionData?.vendor_id,
    selectionData?.branch_id,
    fetchClasses,
    isStudent,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  useEffect(() => {
    if (showClassBatchDropdown && filterData?.class_id) {
      getBatchListData(filterData.class_id);
    } else {
      setBatchList([]);

      if (!isStudent) {
        setFilterData((prev) => ({
          ...prev,
          batch_id: '',
        }));
      }
    }
  }, [
    showClassBatchDropdown,
    filterData?.class_id,
    getBatchListData,
    isStudent,
  ]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData?.vendor_id,
      branchId: selectionData?.branch_id,
    });

    if (canLoad) {
      loadBoard();
    } else {
      setBoard(getDefaultBoard());
    }
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    activeClassId,
    activeBatchId,
    loadBoard,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        const canLoad = conditionalDataLoad({
          hasMultiBranch,
          hasSingleBranch,
          isSuperAdmin,
          isAdmin,
          vendorId: selectionData?.vendor_id,
          branchId: selectionData?.branch_id,
        });

        if (!canLoad) return;

        await createAppConnection();

        const vendorId = selectionData?.vendor_id || 0;
        const branchId = selectionData?.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            console.log('TimeTable realtime update received:', payload);
            loadBoard();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    setupSignalR();

    return () => {
      mounted = false;
    };
  }, [
    selectionData?.vendor_id,
    selectionData?.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    loadBoard,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  const filteredItems = useMemo(() => {
    let rows = Array.isArray(board.items) ? [...board.items] : [];

    if (activeClassId) {
      rows = rows.filter(
        (x) =>
          String(x?.class_id || x?.classId || '') === String(activeClassId),
      );
    }

    if (activeBatchId) {
      rows = rows.filter(
        (x) =>
          String(x?.batch_id || x?.batchId || '') === String(activeBatchId),
      );
    }

    return rows;
  }, [board.items, activeClassId, activeBatchId]);

  const days = useMemo(() => DAYS, []);

  const slots = useMemo(() => {
    return buildTimeSlots(
      board.day_start_time,
      board.day_end_time,
      board.slot_minutes,
    );
  }, [board.day_start_time, board.day_end_time, board.slot_minutes]);

  const minuteHeight = useMemo(() => {
    const slotMinutes = Number(board.slot_minutes || 30);
    return ROW_HEIGHT / slotMinutes;
  }, [board.slot_minutes]);

  const startMinute = useMemo(
    () => parseTimeToMinutes(board.day_start_time || '00:00:00'),
    [board.day_start_time],
  );

  const totalHeight = useMemo(() => (slots.length || 0) * ROW_HEIGHT, [slots]);

  const dayLayouts = useMemo(
    () => buildDayLayouts(days || [], filteredItems || []),
    [days, filteredItems],
  );

  return (
    <div className='time-table-page'>
      {!isStudent && (
        <VendorBranchSelector
          user={user || {}}
          selectionData={selectionData || { vendor_id: '', branch_id: '' }}
          setSelectionData={setSelectionData}
          errorMessage={errorMessage}
          accessButton={true}
        />
      )}

      <Card className='card-box pd-20 mb-20'>
        {showClassBatchDropdown && (
          <Row className='mt-3'>
            <Col md='5'>
              <Label className='form-label'>Class</Label>
              <Input
                type='select'
                className='custom-select'
                value={filterData?.class_id || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterData((prev) => ({
                    ...prev,
                    class_id: value,
                    batch_id: '',
                  }));
                }}
              >
                <option value=''>Select Class</option>
                {classList.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Input>
            </Col>

            <Col md='5'>
              <Label className='form-label'>Batch</Label>
              <Input
                type='select'
                className='custom-select'
                value={filterData?.batch_id || ''}
                disabled={!filterData?.class_id}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilterData((prev) => ({
                    ...prev,
                    batch_id: value,
                  }));
                }}
              >
                <option value=''>Select Batch</option>
                {batchList.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Input>
            </Col>

            <Col md='2' className='d-flex align-items-end'>
              <Button color='success' className='w-100' onClick={loadBoard}>
                Load
              </Button>
            </Col>
          </Row>
        )}

        {isStudent && (
          <Row className='mt-3'>
            <Col md='2' className='d-flex align-items-end ms-auto'>
              <Button color='success' className='w-100' onClick={loadBoard}>
                Load
              </Button>
            </Col>
          </Row>
        )}
        <CardTitle className='border-bottom p-3 mb-0 d-flex justify-content-between align-items-center'>
          <span>Weekly Timetable</span>
          <span className='text-muted small'>
            Time Range: {format12HourTime(board.day_start_time)} -{' '}
            {format12HourTime(board.day_end_time)}
          </span>
        </CardTitle>

        <CardBody>
          {loading ? (
            <div className='text-center p-5'>Loading...</div>
          ) : (
            <div className='weekly-board'>
              <div className='board-header'>
                <div className='time-header-cell'>Time</div>

                {days.map((day) => (
                  <div key={day.day_id} className='day-header-cell'>
                    <div className='day-name'>{day.day_name}</div>
                  </div>
                ))}
              </div>

              <div className='board-body'>
                <div className='time-column' style={{ height: totalHeight }}>
                  {slots.map((slot) => (
                    <div
                      key={slot.label}
                      className='time-row-label'
                      style={{ height: ROW_HEIGHT }}
                    >
                      {slot.label}
                    </div>
                  ))}
                </div>

                {days.map((day) => {
                  const items = dayLayouts[day.day_id] || [];

                  return (
                    <div
                      key={day.day_id}
                      className='day-column'
                      style={{ height: totalHeight }}
                    >
                      {slots.map((slot) => (
                        <div
                          key={`${day.day_id}_${slot.label}`}
                          className='day-grid-row'
                          style={{ height: ROW_HEIGHT }}
                        />
                      ))}

                      {items.map((item, index) => {
                        const top =
                          (item._start - startMinute) * minuteHeight + 4;

                        const height = Math.max(
                          (item._end - item._start) * minuteHeight - 8,
                          56,
                        );

                        const width = `calc(${100 / item._totalCols}% - 8px)`;
                        const left = `calc(${(100 / item._totalCols) * item._colIndex}% + 4px)`;

                        return (
                          <div
                            key={item.id || `${day.day_id}_${index}`}
                            className='timetable-card'
                            style={{ top, height, left, width }}
                          >
                            <div className='tt-title'>
                              {item.subject_name || 'Subject'}
                            </div>

                            <div className='tt-time'>
                              {format12HourTime(item.start_time)} -{' '}
                              {format12HourTime(item.end_time)}
                            </div>

                            <div className='tt-meta'>
                              <strong>Class:</strong> {item.class_name || '-'}
                            </div>

                            <div className='tt-meta'>
                              <strong>Batch:</strong> {item.batch_name || '-'}
                            </div>

                            <div className='tt-meta'>
                              <strong>Faculty:</strong>{' '}
                              {item.faculty_name || '-'}
                            </div>

                            <div className='tt-meta'>
                              <strong>Students:</strong>{' '}
                              {item.student_count || 0}
                            </div>

                            {!!item.student_names_text && (
                              <div className='tt-students'>
                                {item.student_names_text}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default TimeTableBoard;
